import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, ShieldCheck, Pencil, Trophy } from "lucide-react";
import PageShell from "@/components/PageShell";
import Button from "@/components/Button";

const STEPS = [
  {
    Icon: ClipboardList,
    title: "1. Schools Apply for Participation",
    desc: "Schools submit their participation request for the Sprouts Travel Blogging Competition 2026.",
    color: "#3AB0FF",
  },
  {
    Icon: ShieldCheck,
    title: "2. Sprouts Reviews & Confirms Schools",
    desc: "To maintain the quality and credibility of the competition, all school registrations are reviewed and approved by the Sprouts team before participation begins.",
    color: "#FF6B6B",
  },
  {
    Icon: Pencil,
    title: "3. Students Submit Their Stories",
    desc: "Approved schools receive access for students to submit blogs, reels, videos and travel stories from their educational journeys.",
    color: "#FFD166",
  },
  {
    Icon: Trophy,
    title: "4. Champions Celebrated Regionally",
    desc: "Outstanding student stories are recognised as Regional Champions and across our category awards, with recognition through Times NIE & Sprouts Edu Tours platforms.",
    color: "#34D399",
  },
];

export default function HowItWorks() {
  return (
    <PageShell testid="how-it-works-screen">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-black text-sprouts-text">How It Works</h1>
        <p className="text-base text-sprouts-muted mt-2 max-w-2xl">
          A simple Maker-Checker workflow that keeps your school's stories safe and fair.
        </p>

        <div className="mt-8 grid md:grid-cols-2 gap-4">
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`hiw-step-${i}`}
              className="flex gap-4 bg-white rounded-2xl p-5 border border-sprouts-border shadow-soft"
            >
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center shrink-0"
                style={{ backgroundColor: `${s.color}22` }}
              >
                <s.Icon size={24} color={s.color} />
              </div>
              <div>
                <h3 className="font-extrabold text-sprouts-text mb-1">{s.title}</h3>
                <p className="text-sm text-sprouts-muted leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/register">
            <Button data-testid="hiw-register">Register Your School</Button>
          </Link>
          <Link to="/submit">
            <Button variant="secondary" data-testid="hiw-submit">Submit an Entry</Button>
          </Link>
        </div>
      </div>
    </PageShell>
  );
}
